export default "__VITE_ASSET__B9oOv1FW__"